import { CanDeactivateFn } from '@angular/router';

/**
 * Implemented by views that stage edits locally and apply them on an explicit Save
 * (Azure-portal pattern) — leaving with staged changes discards them, so the route
 * guard asks first via the component's own confirmation dialog.
 */
export interface HasPendingChanges {
  hasPendingChanges(): boolean;
  /** Opens the component's discard-confirmation dialog; resolves true to allow leaving. */
  confirmLeave(): Promise<boolean>;
}

/**
 * Blocks navigation away from a component with staged, unsaved changes until the user
 * confirms the discard in the component's dialog. Pair with a window:beforeunload handler
 * in the component for tab-close/refresh coverage — this guard only sees in-app navigation.
 */
export const pendingChangesGuard: CanDeactivateFn<HasPendingChanges> = (component) =>
  !component.hasPendingChanges() || component.confirmLeave();
